import { useTranslation } from 'react-i18next';
import { StatsCategory, StatsCounts } from '../../helpers/locationStatistics';

export const StatsValue = ({ value }: { value: number | null }) => {
    const { t, i18n } = useTranslation();
    return value === null ? <><span aria-hidden="true">&mdash;</span><span className="sr-only">{t('stats.unknown')}</span></>
        : <>{new Intl.NumberFormat(i18n.resolvedLanguage || i18n.language || 'pl').format(value)}</>;
};

export const StatsMetrics = ({ counts }: { counts: StatsCounts }) => {
    const { t } = useTranslation();
    return <dl className="stats-metrics">
        {(['institutions', 'objects', 'points'] as const).map(metric => <div key={metric}>
            <dt>{t(`stats.${metric}`)}</dt><dd><StatsValue value={counts[metric]} /></dd>
        </div>)}
    </dl>;
};

export const StatsTableHeaders = () => {
    const { t } = useTranslation();
    return <thead><tr><th scope="col">{t('stats.category')}</th>
        <th scope="col"><span className="stats-column-full">{t('stats.institutions')}</span><span className="stats-column-short" aria-hidden="true">{t('stats.institutionsShort')}</span></th>
        <th scope="col">{t('stats.objects')}</th><th scope="col">{t('stats.points')}</th>
    </tr></thead>;
};

export const StatsDetailRow = ({ details, label }: { details: StatsCategory[]; label: string }) => {
    const { t } = useTranslation();
    return <div className="stats-table-scroll">
        <table className="stats-table stats-detail-table" tabIndex={0}>
            <caption className="sr-only">{label}</caption>
            <StatsTableHeaders />
            <tbody>{details.map(detail => <tr key={detail.id}>
                <th scope="row">{t(`stats.category_${detail.id}`)}</th>
                <td><StatsValue value={detail.institutions} /></td><td><StatsValue value={detail.objects} /></td><td><StatsValue value={detail.points} /></td>
            </tr>)}</tbody>
        </table>
    </div>;
};
